import React, {useState, useEffect} from 'react';

function Timer({lastUpdatedTime}) {
    const [remainingTime, setReaminingTime] = useState({
        min: 0,
        sec: 0
    });

    useEffect(() => {
        const interval = setInterval(() => {
            if(remainingTime.sec === 60){
                setReaminingTime({
                    min: min + 1,
                    sec: 0
                })
            }else {
                setReaminingTime({
                    ...remainingTime,
                    sec: sec + 1
                })
            }

        }, 1000);
        return () => clearInterval(interval);
    });

    useEffect(() => {
        // get total seconds between the times
        var delta = Math.abs(new Date() - new Date(lastUpdatedTime)) / 1000;

        // calculate (and subtract) whole days
        var days = Math.floor(delta / 86400);
        delta -= days * 86400;

        // calculate (and subtract) whole hours
        var hours = Math.floor(delta / 3600) % 24;
        delta -= hours * 3600;

        // calculate (and subtract) whole minutes
        var minutes = Math.floor(delta / 60) % 60;
        delta -= minutes * 60;

        // what's left is seconds
        var seconds = delta % 60;

        setReaminingTime({
            min: Math.round(minutes),
            sec: Math.round(seconds)
        })

    }, [lastUpdatedTime]);

    const {min, sec} = remainingTime;
    var displayTime 
    var thisStyle

    if ( min == 0 ) {
	displayTime = sec + 's ago'
    } else {
	displayTime = min + 'm ' + sec + 's ago'
	thisStyle = ' style="color:red"'
    }

    return (
        <>
            <span style={{color: min > 2 ? "red" : "#1d9939", float: "right", width: "120px"}}>({displayTime})</span>
        </>
    )
//    return (
//        <>
//            <span>({min}m {sec}s ago)</span>
//        </>
//    )
}

export default Timer;
